import React, { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useKeycloak } from "@/modules/auth/context/KeycloakContext";
import { isSessionExpiredActive } from "@/lib/authSession";

export const ProtectedRoute: React.FC = () => {
  const { authenticated, keycloak } = useKeycloak();
  const loginTriggered = useRef(false);
  const sessionExpired = isSessionExpiredActive();

  useEffect(() => {
    if (sessionExpired) return;
    if (!authenticated && keycloak && !loginTriggered.current) {
      loginTriggered.current = true;
      keycloak.login({ redirectUri: window.location.href });
    }
  }, [authenticated, keycloak, sessionExpired]);

  if (!authenticated && !sessionExpired) {
    return (
      <div className="h-screen w-screen flex flex-col items-center justify-center bg-bridge-bg">
        <div className="w-12 h-12 border-4 border-bridge-accent/20 border-t-bridge-accent rounded-full animate-spin mb-4" />
        <p className="text-sm font-medium text-bridge-muted">Redirecting to login...</p>
      </div>
    );
  }

  return <Outlet />;
};
